import { useEffect } from 'react'
import { Outlet, useSearchParams, useLocation } from 'react-router-dom'
//import '@assets/css/common/style_main.css'
import Header from './Header'
import Sidebar from './Sidebar'
import Footer from './Footer'

function AdminLayout() {
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    // URL 파라미터에서 에러 메시지 확인 및 표시
    useEffect(() => {
        const errorMsg = searchParams.get('error_msg');
        if (errorMsg) {
            alert(decodeURIComponent(errorMsg));
            searchParams.delete('error_msg');
            setSearchParams(searchParams, { replace: true });
        }
    }, [location.search]);

    return (
        <div className="dashboard-container">
            {/* 사이드바 컨테이너 */}
            <div id="sidebar-container">
                <Sidebar />
            </div>

            {/* 헤더 컨테이너 */}
            <div id="header-container">
                <Header />
            </div>

            {/* 메인 콘텐츠 시작 */}
            <div className="content-wrapper fade-transition">
                <Outlet />
            </div>
            <Footer />
        </div>
    );
}

export default AdminLayout